import {OnlyTextHeaderArg} from "@psdk/frame-father";

export class CGap extends OnlyTextHeaderArg<CGap> {
  header(): string {
    return 'GAP-SENSE';
  }
}
